module.exports = __webpack_public_path__ + "img/ep7-6b.e0da8cea.png";